<script setup lang="ts">
import type { Order } from '@shared/types/models'
import SolidButton from '@shared/components/Buttons/SolidButton.vue'
import Tip from '@shared/components/Tip.vue'
import PaymentForm from '@shared/components/Payment/PaymentForm.vue'
import StatusPageUi from '@/components/Ui/StatusPageUi.vue'

type Props = {
    order: Order
}

const { order } = defineProps<Props>()
</script>

<template>
    <status-page-ui>
        <template #image>
            <img src="/storage/cat-sitting.svg" alt="Thank you" class="w-full" />
        </template>

        <template #title>
            <span v-if="order.visited_thanks_page"
                >{{ $trans.get('order.order') }} #{{ order.id }}</span
            >
            <span v-else>{{ $trans.get('order.thank_you_for_order') }}</span>
        </template>

        <template #description>
            <span v-if="order.disallow_payment === null">
                {{ $trans.get('order.we_will_process_you_order') }}
            </span>
            <span v-else>{{ order.disallow_payment }}</span>
        </template>

        <template #actions>
            <payment-form v-if="order.disallow_payment === null" :order>
                <solid-button
                    type="submit"
                    class="bg-main-pink hover:bg-main-pink-hover"
                    icon="lni-dollar"
                >
                    {{ $trans.get('order.pay_for_order') }}
                </solid-button>
            </payment-form>

            <tip v-else :content="order.disallow_payment">
                <solid-button
                    href="javascript:"
                    class="bg-gray-800 hover:bg-gray-800 opacity-50 cursor-not-allowed"
                    icon="lni-dollar"
                    disabled
                >
                    {{ $trans.get('order.pay_for_order') }}
                </solid-button>
            </tip>

            <solid-button
                href="/"
                class="bg-transparent hover:border-black border border-gray-400 !text-gray-600 hover:bg-transparent hover:!text-black"
                icon="lni-home"
            >
                {{ $trans.get('common.go_back_home') }}
            </solid-button>
        </template>
    </status-page-ui>
</template>
